import type { SystemVersionDTO } from "@repo/codegen/teashop-base-api"

export type BusinessContextRequestVersion =
  | {
    mode: "inherit"
    version: undefined
  }
  | {
    mode: "discover"
    version: null
  }
  | {
    mode: "target"
    version: SystemVersionDTO
  }

/**
 * `undefined` is deliberately different from `null`:
 * - undefined: a normal request inherits the committed context;
 * - null: a version-discovery request must not inherit context headers;
 * - DTO: a preparing transaction uses the target context explicitly.
 */
export function resolveBusinessContextRequestVersion(
  version: SystemVersionDTO | null | undefined,
): BusinessContextRequestVersion {
  if (version === undefined) {
    return { mode: "inherit", version: undefined }
  }
  if (version === null) {
    return { mode: "discover", version: null }
  }
  return { mode: "target", version }
}
